import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { formatCurrencyToLocale } from "../../../../utils/method";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function BudgetVarianceChart({ data = [] }) {
    const { t } = useTranslation();

    const chartData = {
        labels: data.map(item => item.code),
        datasets: [
            {
                label: t("costTracking.budget"),
                data: data.map(item => item.budget),
                backgroundColor: 'rgba(54, 162, 235, 0.8)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1,
            },
            {
                label: t("costTracking.actual"),
                data: data.map(item => item.actual),
                backgroundColor: 'rgba(255, 99, 132, 0.8)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: t("costTracking.budget-vs-actual"),
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return `${context.dataset.label}: ${formatCurrencyToLocale(context.parsed.y)}`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return formatCurrencyToLocale(value);
                    }
                }
            },
        },
    };

    return (
        <Card>
            <Card.Header>
                <h6 className="mb-0">{t("costTracking.budget-variance-chart")}</h6>
            </Card.Header>
            <Card.Body>
                <Bar data={chartData} options={options} />
            </Card.Body>
        </Card>
    );
}

export default BudgetVarianceChart;